module.exports = __webpack_public_path__ + "assets/cover_0_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_0_old.jpg
 ** module id = 205
 ** module chunks = 1
 **/